/* eslint-disable no-param-reassign */

import * as types from './mutationTypes';

export default {
  [types.SET_SPACE](state, space) {
    const spaces = { ...state.spaces, ...space };
    state.spaces = spaces;
  },
  [types.RESET_SPACE](state) {
    const spaces = {
      ceoCabin: {
        area: 320,
        unit: 0,
      },
      seniorManagementOffice: {
        area: 150,
        unit: 0,
      },
      office: {
        area: 100,
        unit: 0,
      },
      workstations: {
        area: 20,
        unit: 0,
      },
      reception: {
        area: 600,
        unit: 0,
      },
      miniMettingRoom: {
        area: 80,
        unit: 0,
      },
      smallMettingRoom: {
        area: 180,
        unit: 0,
      },
      middleMettingRoom: {
        area: 280,
        unit: 0,
      },
      largeMettingRoom: {
        area: 500,
        unit: 0,
      },
      storeRoom: {
        area: 150,
        unit: 0,
      },
      storageInOpenArea: {
        area: 200,
        unit: 0,
      },
      serverRoomAndUpsRoom: {
        area: 200,
        unit: 0,
      },
      toilet: {
        area: 800,
        unit: 0,
      },
      otherArea: {
        area: 0,
        unit: 0,
      },
    };
    state.spaces = spaces;
  },
};
